import { useEffect } from "react";
import { createPortal } from "react-dom";
import "./ConfirmModal.css";

const ConfirmModal = ({
  open,
  title,
  children,
  confirmText = "Hapus",
  cancelText = "Batal",
  loading = false,
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape" && !loading) onCancel();
    };
    const prevOverflow = document.body.style.overflow;
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, loading, onCancel]);

  if (!open) return null;

  return createPortal(
    <div
      className="cm-overlay"
      onClick={() => !loading && onCancel()}
      role="presentation"
    >
      <div
        className="cm-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="cm-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cm-icon" aria-hidden="true">
          <svg
            width="26"
            height="26"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 6h18" />
            <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
            <path d="M10 11v6M14 11v6" />
          </svg>
        </div>

        <h3 id="cm-title" className="cm-title">
          {title}
        </h3>
        <div className="cm-body">{children}</div>

        <div className="cm-actions">
          <button
            type="button"
            className="cm-btn cm-btn--ghost"
            onClick={onCancel}
            disabled={loading}
            autoFocus
          >
            {cancelText}
          </button>
          <button
            type="button"
            className="cm-btn cm-btn--danger"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? <span className="cm-spinner" /> : null}
            {loading ? "Menghapus..." : confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmModal;
